import { reactive } from "vue";
export const useAuth = reactive({
  token: null,
  login: false,
  setToken(token) {
    this.token = token, this.login = true;
  },
  setLogout() {
    this.token = null, this.login = false;
  },
  getToken() {
    return this.token;
  },
  getLogin() {
    return this.login;
  }
});
